import { message } from 'antd'
import { put, takeEvery } from 'redux-saga/effects'
import call from '../call'
import { APP, LOADING } from '../actionTypes'

import {
  logout as logoutService,
  getUserInfo as getUserInfoService,
  getUserResources as getUserResourcesService,
  getWeather as getWeatherService,
} from '../service/app'

type UserInfoData = {
  data: UserInfo
}

export function* getUserInfo(payload: Payload) {
  const data: ResponseData & UserInfoData = yield call(getUserInfoService, payload)
  if (data && data.code === 0) {
    yield put({
      type: APP.UPDATE_STATE,
      payload: { userInfo: data.data },
    })
    if (window.owl) {
      const { misId, userName } = data.data?.user || {}
      window.owl('setDimension', {
        unionId: misId ? misId : userName,
      })
    }
    if (data.data && !data.data.entity?.length) {
      message.error('当前账号无监管实体，请联系管理员授权！')
      yield put({
        type: APP.LOG_OUT,
        cb: () => {
          location.hash = '/login'
        },
      })
    }
    payload.cb && payload.cb()
  }
}

export function* getUserResources(payload: Payload) {
  const data: ResponseData = yield call(getUserResourcesService, payload, {
    loadingName: LOADING.RESOURCE,
  })
  if (data && data.code === 0) {
    yield put({
      type: APP.UPDATE_STATE,
      payload: { userResources: data.data },
    })
    const hasDatarCenter = data?.data?.some((item: { id: number }) => item.id === 1)
    if (!hasDatarCenter && window.location.href.includes('/dataCenter')) {
      window.location.hash = '/manageCenter'
    }
  }
}

export function* logout(payload: Payload) {
  const data: ResponseData = yield call(logoutService, payload)
  if (data && data.code === 0) {
    yield put({
      type: APP.UPDATE_STATE,
      payload: { userInfo: {}, region: {}, selectedBiz: '', userResources: [] },
    })
    payload.cb && payload.cb()
  }
}

export function* getWeather(payload: Payload) {
  const data: ResponseData = yield call(getWeatherService, payload)
  if (data && data.code === 0) {
    yield put({
      type: APP.UPDATE_STATE,
      payload: { weather: data.data },
    })
  }
}

export default function* root() {
  yield takeEvery(APP.GET_USER_INFO, getUserInfo)
  yield takeEvery(APP.GET_USER_RESOURCES, getUserResources)
  yield takeEvery(APP.LOG_OUT, logout)
  yield takeEvery(APP.GET_WEATHER, getWeather)
}
